module.exports = __webpack_public_path__ + "img/bl.ebfec527.svg";